export * from './field.model';
export * from './list-item.model';
export * from './field-mapping.model';
export * from './fcmMessage.model';
export * from "./enums.model";
export * from "./constants.model";
// Salesnow API models
export * from "./company.model";
export * from "./contact.model";
export * from "./lead.model";
export * from "./deal.model";
export * from "./case.model";
export * from "./email.model";
export * from "./call.model";
export * from "./meeting.model";
export * from "./task.model";
export * from "./opportunity.model";
export * from "./event.model";
export * from "./model.model";
// search model
export * from "./search.model";
// SalesNOW system models
export * from './user.model';
export * from './device.model';
export * from "./condition.model";



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/index.ts